import { React } from "react";
import FormsTable from "./FormsTable";
import "../index.css";

export default function SelectForm({
  products,
  goToSummary,
  handleProductSelection,
}) {
  return (
    <div>
      <h4 className="text-2xl font-semibold">Select Form</h4>
      <p className="leading-relaxed mt-1 text-gray-600 mb-2">
        You can change the selection of your form below. If you previously opted
        to add an additional form to your purchase, that form will be removed
        from the order.
      </p>

      <FormsTable
        navigateTo={goToSummary}
        handleProductSelection={handleProductSelection}
        products={products}
      />

      <div className="text-center flex justify-between mt-6">
        <button
          className="text-white bg-black focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={goToSummary}
        >
          Cancel
        </button>
      </div>
      {/*       <p className={unexpectedError ? "text-red-600 text-s mt-2" : "hidden"}>
        {unexpectedError.message}
      </p> */}
    </div>
  );
}
